import { Box, Checkbox, Typography } from "@mui/material";
import { ListSelectProps } from "./index";

type AllSelectHeaderProps = Pick<
  ListSelectProps,
  "allSelected" | "onAllSelect"
>;

export function AllSelectHeader({
  allSelected = false,
  onAllSelect,
}: AllSelectHeaderProps) {
  return (
    <Box sx={{ padding: "4px" }}>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <Checkbox
          checked={allSelected}
          size="small"
          sx={{ padding: 0 }}
          onClick={() => onAllSelect?.(allSelected)}
        />
        <Typography variant="body2" color="text.primary">
          전체 선택
        </Typography>
      </Box>
    </Box>
  );
}
